exports.components = {
  "component---src-components-templates-recipe-tsx": () => import("./../../../src/components/templates/recipe.tsx" /* webpackChunkName: "component---src-components-templates-recipe-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

